import { useAuth } from "./AuthContextProvider";
import { Navigate } from "react-router-dom";
import { useCore } from "./CoreContextProvider";
import Layout from "../layout/Layout.page";
import LoadingSpinner from "../common/Loading";
import PropTypes from "prop-types";

export const AuthenticatedRoute = ({ component: RouteComponent }) => {
 const { coreLoading } = useCore();
 const roles = ["fitfreshadmin"];
 const { authLoading, userData } = useAuth();
 if (coreLoading || authLoading) {
  return <LoadingSpinner />;
 } else {
  const userHasRequiredRole =
   userData && roles.includes(userData.role) ? true : false;
  if (userData && userHasRequiredRole) {
   return (
    <Layout>
     <RouteComponent />
    </Layout>
   );
  }
  if (userData && !userHasRequiredRole) {
   return (
    <Layout>
     <div> Error Handling Request! </div>
    </Layout>
   );
  }
  return <Navigate to="/" />;
 }
};

AuthenticatedRoute.propTypes = {
 component: PropTypes.any.isRequired,
};
